import { reduxAPI } from "../redux/reduxAPI";
import {
  getQueryStringWithCreator,
  postQueryBodyWithCreator,
} from "../utils/reduxHelper";
/**
 * FTUX Service for handling First-Time User Experience API calls
 * Based on the backend FTUX API endpoints
 */

// FTUX API endpoints
const FTUX_ENDPOINTS = {
  SUBMIT_FTUX_FORM: "c/submitFTUXForm",
  GET_FTUX_FORM_STATUS: "c/getFTUXFormData",
  MARK_FEATURE_VISITED: "c/markFeatureVisited",
  GET_FTUX_HOME_TAKEOVER_FLOW: "c/getFTUXHomeTakeoverFlow",
  GET_FTUX_DETAILS: "c/getFTUXDetails",
};

// Enhanced FTUX API slice
export const ftuxAPI = reduxAPI.injectEndpoints({
  endpoints: (builder) => ({
    // Get FTUX flow for a specific feature
    submitFTUXForm: builder.mutation({
      query: (body) => ({
        url: FTUX_ENDPOINTS.SUBMIT_FTUX_FORM,
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
    }),
    getFTUXFormStatus: builder.query({
      query: (feature) =>
        `${getQueryStringWithCreator(
          FTUX_ENDPOINTS.GET_FTUX_FORM_STATUS
        )}&feature=${feature}`,
    }),
    getFTUXHomeTakeoverFlow: builder.query({
      query: () => ({
        url: getQueryStringWithCreator(
          FTUX_ENDPOINTS.GET_FTUX_HOME_TAKEOVER_FLOW
        ),
        method: "GET",
      }),
      providesTags: ["FTUX"],
    }),
    getFTUXDetails: builder.query({
      query: (feature) =>
        `${getQueryStringWithCreator(
          FTUX_ENDPOINTS.GET_FTUX_DETAILS
        )}&feature=${feature}`,
      providesTags: ["FTUX"],
    }),
    postMarkFeatureVisited: builder.mutation({
      query: (body) => ({
        url: FTUX_ENDPOINTS.MARK_FEATURE_VISITED,
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
      invalidatesTags: ["QuickAccessIndicators", "FTUX", "COCEvent"],
    }),
  }),
});

// Export hooks for use in components
export const {
  useSubmitFTUXFormMutation,
  useGetFTUXFormStatusQuery,
  useGetFTUXHomeTakeoverFlowQuery,
  useGetFTUXDetailsQuery,
  usePostMarkFeatureVisitedMutation,
} = ftuxAPI;

// Utility functions for FTUX
export const ftuxUtils = {
  // Format collab form data for API
  formatCollabFTUXFormData: (formData) => {
    try {
      const categories = Array.isArray(formData?.categories)
        ? formData.categories
        : [];
      let data = {
        categories: categories,
        collabPricing: {
          reel_story: formData.collabReelPrice,
          non_collab_reel_story: formData.nonCollabReelPrice,
          ads_rights: formData.adsRightsPrice,
        },
        pastCollabs: {
          has_past_collabs: formData.hasPastCollabs,
          brand_names: formData.hasPastCollabs ? formData.pastBrandName : "",
        },
      };
      if (categories.map((c) => c.toLowerCase()).includes("others")) {
        data.customCategory = formData.customCategory;
      }
      data.feature = "COLLAB";
      return data;
    } catch (error) {
      return {};
    }
  },
};
